import React from 'react'
import { connect } from 'react-redux'
import classNames from 'classnames'
import { useHistory, useLocation } from 'react-router-dom'

import LogoImg from 'i/talkpro_logo.png'
import validPaths from 'utils/validPaths'

const Logo = (props) => {
  const logoClasses = classNames('header_logo', {
    pro_join_mod: props.proJoinPageMod,
  })

  const history = useHistory()
  const location = useLocation()

  const handleLogoClick = (e) => {
    if (validPaths.pathnames.includes(location.pathname)) {
      history.goBack()
    } else {
      e.preventDefault()
    }
  }

  return (
    <div className={logoClasses} onClick={handleLogoClick}>
      <img className="inner_img" src={LogoImg} alt="Logo" />
    </div>
  )
}

const mapStateToProps = ({ auth: { error, user, isPro } }) => ({
  authError: error,
  user,
  isPro,
})

export default connect(mapStateToProps)(Logo)
